exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".AddHistoryItem__form___3OcUJ {\n  padding: 1em;\n  display: flex;\n  align-items: stretch;\n  flex-direction: column; }\n  .AddHistoryItem__form___3OcUJ .AddHistoryItem__buttons___2WCrK {\n    display: flex;\n    align-items: stretch;\n    justify-content: space-around; }\n    .AddHistoryItem__form___3OcUJ .AddHistoryItem__buttons___2WCrK button {\n      margin-top: 20px; }\n  .AddHistoryItem__form___3OcUJ .AddHistoryItem__label___1kr2_ {\n    display: flex;\n    align-items: stretch;\n    flex-direction: column;\n    margin-top: .2em; }\n    .AddHistoryItem__form___3OcUJ .AddHistoryItem__label___1kr2_ .AddHistoryItem__caption___yGJmK {\n      font-size: .9em; }\n    .AddHistoryItem__form___3OcUJ .AddHistoryItem__label___1kr2_ input {\n      border: 0;\n      width: 100%;\n      padding: 8px;\n      outline: none;\n      font-size: 20px;\n      color: #6b6767;\n      box-sizing: border-box;\n      border-bottom: 1px solid #A7A7A7; }\n", ""]);

// exports
exports.locals = {
	"form": "AddHistoryItem__form___3OcUJ",
	"buttons": "AddHistoryItem__buttons___2WCrK",
	"label": "AddHistoryItem__label___1kr2_",
	"caption": "AddHistoryItem__caption___yGJmK"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules=true&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/sass-loader?includePaths[]=./src/styles!./src/components/Forms/AddHistoryItem/AddHistoryItem.scss
// module id = 868
// module chunks = 0